export default __webpack_public_path__ + "static/media/sport-kid.26c6dd50.jpg";